<template>
  <div class="section-options">
    <div class="header">
      <h3>{{ $t("editor-section.section-options") }}</h3>
    </div>
    <form @submit.stop.prevent>
      <custom-input
        :inputType="'text'"
        v-model="newOptions.name"
        :name="'nameInput'"
        :label="$t('editor-section.rename-label')"
        :placeholder="$t('enter-name')"
        :focusInputField="true"
      />
      <custom-input
        :inputType="'text'"
        v-model="newOptions.id"
        :name="'idInput'"
        :label="$t('editor-section.id-label')"
        :placeholder="'Id'"
        :focusInputField="true"
      />
      <span class="text-xs text-danger" v-if="templateSection.id != newOptions.id">{{
        $t("editor-section.id-desc")
      }}</span>
      <div class="checkbox-wrapper" v-if="!isAiSection">
        <checkbox
          class="checkbox"
          :label="$t('editor-section.paragraph')"
          :name="'paragraphs'"
          v-model="newOptions.paragraph"
          lightLabel
        />

        <span :tooltip="$t('editor-section.paragraph-desc')"><i class="fa-light fa-circle-question"></i></span>
      </div>
      <div class="checkbox-wrapper">
        <checkbox
          class="checkbox"
          :label="$t('editor-section.active-section')"
          :name="'active'"
          v-model="newOptions.active"
          lightLabel
        />
        <span :tooltip="$t('editor-section.active-section-desc')"
          ><i class="fa-light fa-circle-question"></i
        ></span>
      </div>

      <span class="text-danger text-xs">
        <span v-if="nameOrIdIsReserved">{{ $t("rename.name-reserved") }}</span>
        <span v-if="!emptyFields">{{
          nameOrIdIsReserved ? $t('editor-section.id-undefined-1') : $t('editor-section.id-undefined-2')
        }}</span>
      </span>

      <div class="actions">
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="nameOrIdIsReserved || !emptyFields"
          @click="onSaveChanges"
        >
          {{ $t("save") }}
        </button>
        <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ $t("cancel") }}</button>
      </div>
    </form>
  </div>
</template>
<script>
import Checkbox from "@/components/Checkbox";
export default {
  name: "SectionOptionsModal",
  components: {
    Checkbox
  },
  props: {
    templateSection: Object,
    onSave: Function
  },
  data() {
    return {
      newOptions: {
        name: "",
        id: "",
        paragraph: false,
        active: false
      }
    };
  },
  computed: {
    isAiSection() {
      return this.templateSection.type == "ai";
    },
    invalidOptions() {
      return this.$store.getters.getInvalidSectionNames.filter(
        (n) => ![this.templateSection.name, this.templateSection.id].includes(n)
      );
    },
    emptyFields() {
      return this.newOptions.name.length > 0 && this.newOptions.id.length > 0;
    },
    nameOrIdIsReserved() {
      return (
        this.invalidOptions.includes(this.newOptions.name) ||
        this.invalidOptions.includes(
          this.newOptions.name
            .toLowerCase()
            .replaceAll(/[^\w ]+/g, "")
            .replaceAll(/ +/g, "")
        ) ||
        (this.invalidOptions.includes(this.newOptions.id) ||
          this.invalidOptions.includes(
            this.newOptions.id
              .toLowerCase()
              .replaceAll(/[^\w ]+/g, "")
              .replaceAll(/ +/g, "")
          ))
      );
    }
  },
  methods: {
    onToggleActivate() {
      this.newOptions.active = !this.newOptions.active;
    },
    onSaveChanges() {
      this.onSave(this.newOptions);
      this.$emit("close");
    }
  },
  created() {
    this.newOptions = {
      name: this.templateSection.name,
      id: this.templateSection.id,
      paragraph: this.templateSection.paragraph,
      active: this.templateSection.active
    };
  }
};
</script>
<style lang="less">
.section-options {
  padding: 20px;

  .header {
    display: flex;
    justify-content: space-between;
    h3 {
      margin: 0;
    }
  }
  .checkbox-wrapper {
    margin-top: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    .container-checkbox {
      margin: 0;
    }
  }
  .actions {
    margin-top: 12px;
    display: flex;
    gap: 12px;
  }
}
</style>
